<template>
  <div>
    <Head />
    <div class="layout">
      <div class="message">
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p class="tit">{{ $t("message.part1.tit") }}</p>
              <p class="text">NEWS</p>
            </div>
            <div class="right">
              <img src="../../assets/images/pc/message/hand.png" alt="" />
            </div>
          </div>
        </div>
        <div class="part-2" id="part2">
          <!-- <div class="part2" v-if="reportList.length > 0"> -->
          <div class="main">
            <ul class="ul">
              <router-link
                tag="li"
                class="item"
                v-for="(item, index) in List"
                :key="index"
                :to="'/newsdetail/' + item.id"
              >
                <div class="item-img">
                  <img :src="item.pic" />
                </div>
                <div class="item-info">
                  <div class="item-title">{{ item.title }}</div>

                  <div class="item-desc">{{ item.description }}</div>
                  <div class="item-date">
                    <span>{{ $t("message.part2.time") }}</span>
                    {{ item.createdTime }}
                  </div>
                </div>
              </router-link>
            </ul>
            <div class="fy">
              <!-- <div class="left">
                <span>共{{pages}}页</span>
                &nbsp;&nbsp;
                <span>共{{total}}条信息</span>
              </div> -->
              <div class="right">
                <Page
                  :total="total"
                  :page-size="rows"
                  :current="page"
                  @on-change="changepage"
                />
              </div>
            </div>
            <div style="clear: both; display: block; height: 30px"></div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/pc/Head";
import Foot from "../../components/pc/Foot";
import { Button, Spin, Page } from "iview";
import defalt from "../../assets/images/pc/message/defalt.png";
import api from "../../common/api";
export default {
  name: "newslist",
  components: {
    Head,
    Foot,
    Button,
    Spin,
    Page,
  },
  data() {
    return {
      List: [],
      totalList: [],
      page: 1,
      rows: 12,
      lang: "en",
      total: 0,
      pages: 0,
      defalt,
    };
  },
  created() {
    this.getImg();
    this.getList();
  },
  mounted() {
    this.mobile();
  },

  methods: {
    getImg() {
      this.lang = localStorage.Lang || "en";
    },
    getList() {
      this.$axios
        .get(api.getReportList, {
          params: {
            rows: this.rows,
            page: this.page,
            lang: this.lang,
          },
        })
        .then((res) => {
          this.total = res.data.total;
          let list = res.data.list;
          this.List = [];
          list.map((data) => {
            this.List.push({
              id: data.id,
              pic: data.picSmall || this.defalt,
              title: data.title,
              createdTime: data.createdTime.substring(0, 10),
              description: data.description,
            });
          });
          this.pages = parseInt((this.total + this.rows - 1) / this.rows);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changepage(index) {
      this.page = index;
      //document.getElementById("part2").scrollIntoView(true)
      this.getList();
    },
    mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if ((flag && flag.length) > 0) {
        this.$router.replace("/mobile" + this.$route.path);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  min-width: @min-width;
  background-color: #f8f9fb;
}

.message {
  background: #ffffff;
  .part-1 {
    height: 509px;
    margin-top: 70px;
    background: url("../../assets/images/pc/message/bg.png") no-repeat center;
    background-size: auto 509px;
    .main {
      .left {
        width: 46%;
        float: left;
        .tit {
          margin: 196px 0 0 80px;
          font-size: 40px;
          line-height: 40px;
          color: rgba(255, 255, 255, 1);
        }
        .text {
          margin: 14px 0 0 163px;
          font-size: 60px;
          color: rgba(255, 255, 255, 1);
          opacity: 0.12;
          line-height: 60px;
        }
      }
      .right {
        width: 54%;
        float: left;
        img {
          margin: 84px 0 0 120px;
          width: 367px;
          height: 355px;
        }
      }
    }
  }
  .part-2 {
    width: 100%;
    padding-top: 75px;
    background-color: #ffffff;
    .main {
      padding: 0;
      .clearfix();
      .ul {
        display: flex;
        flex-wrap: wrap;

        .item {
          width: 360px;
          height: 423px;
          margin: 10px;
          cursor: pointer;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          .item-img {
            width: 100%;
            height: 240px;

            img {
              width: auto;
              height: auto;
              max-width: 100%;
              max-height: 100%;
            }
          }

          .item-info {
            padding: 30px 24px;
            height: 183px;
            .item-title {
              width: 100%;
              font-size: 20px;
              color: #444444;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              line-height: 20px;
            }

            .item-desc {
              margin: 16px 0;
              height: 59px;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              font-size: 14px;
              color: #888888;
              line-height: 20px;
            }
            .item-date {
              font-size: 14px;
              color: #bababa;
            }
          }
        }
      }
      .fy {
        margin: 30px auto;
        .left {
          float: left;
          width: 120px;
          margin-right: 300px;
          span {
            font-size: 12px;
            font-weight: 400;
            color: rgba(100, 100, 100, 1);
            line-height: 26px;
          }
        }
        .right {
          ul {
            text-align: center;
          }
          /deep/.ivu-page-item {
            min-width: 40px;
            height: 40px;
            line-height: 40px;
          }
          /deep/.ivu-page-item-active {
            background: rgba(80, 145, 253, 1);
          }
          /deep/.ivu-page-item-active a,
          .ivu-page-item-active:hover a {
            color: #ffffff;
          }
          /deep/.ivu-page-prev {
            min-width: 40px;
            height: 40px;
            line-height: 32px;
            a {
              font-size: 20px;
              color: rgba(102, 102, 102, 1);
            }
          }
          /deep/.ivu-page-next {
            min-width: 40px;
            height: 40px;
            line-height: 32px;
            a {
              font-size: 20px;
              color: rgba(102, 102, 102, 1);
            }
          }
        }
      }
    }
  }
}
</style>